import React from "react";
import styled from "styled-components";
import { Link, navigate } from "gatsby";
import media from "styled-media-query";

import MainImage1 from "../img/torii-1.jpg";
import MainImage2 from "../img/kado-1.jpg";
import MainImage3 from "../img/nawate-1.jpg";
//import MainImage4 from "../img/kiraku-1.jpg";

const Facilities = () => {
    return(
        <Body>
            <Midashi>施設のご紹介</Midashi>

        <FacilitiesDiv>
            <Column>
                <ImageSmall src={MainImage1} onClick={()=>{navigate("/facility/toriikuguru")}}></ImageSmall>
                <Komidashi onClick={()=>{navigate("/facility/toriikuguru")}}>Guesthouse&Lounge</Komidashi>
                <Midashi onClick={()=>{navigate("/facility/toriikuguru")}}>とりいくぐる</Midashi>
                <p onClick={()=>{navigate("/facility/toriikuguru")}}>泊まる、食べる、散歩する。とりいをくぐって入る、家のようなゲストハウス</p>
            </Column>
            <Column>
                <ImageSmall src={MainImage2} onClick={()=>{navigate("/facility/roungekado")}}></ImageSmall>
                <Komidashi onClick={()=>{navigate("/facility/roungekado")}}>奉還町4丁目</Komidashi>
                <Midashi onClick={()=>{navigate("/facility/roungekado")}}>ラウンジ・カド</Midashi>
                <p onClick={()=>{navigate("/facility/roungekado")}}>食べたり、飲んだり、話したり。 街を眺めるラウンジ</p>
            </Column>
            <Column>
                <ImageSmall src={MainImage3} onClick={()=>{navigate("/facility/nawate")}}></ImageSmall>
                <Midashi onClick={()=>{navigate("/facility/nawate")}}>NAWATE</Midashi>
                <br />
                <p onClick={()=>{navigate("/facility/nawate")}}>ゲストハウスとお店、アトリエが入居している、小さくも多様な人の集まる複合施設</p>
            </Column>
        </FacilitiesDiv>
        </Body>
    )
}

export default Facilities;

const Body = styled.div`
  width: 100vw;
  background: #ffffff;
  
  ${media.lessThan("medium")`
    /* screen width is less than 768px (medium) */
    padding: 10vh 5vw 1vh 5vw;
  `}
  ${media.greaterThan("medium")`
    /* screen width is greater than 1170px (large) */
    padding: 10vh 5vw 10vh 5vw;
  `}
`;

const FacilitiesDiv = styled.div`
  justify-content: space-between;
  margin: 10vh 0 10vh 0;
  ${media.lessThan("medium")`
    /* screen width is less than 768px (medium) */
    display: flex;
    flex-wrap: wrap;
  `}
  ${media.greaterThan("medium")`
    /* screen width is greater than 1170px (large) */
    display: flex;
  `}
`;

const Column = styled.div`
  ${media.lessThan("medium")`
    /* screen width is less than 768px (medium) */
    width: 40vw;
    margin: 0 0 2vh 0;
  `}
  ${media.greaterThan("medium")`
    /* screen width is greater than 1170px (large) */
    width: 20vw;
  `}
`;

const ImageSmall = styled.img`
  border-radius: 10px;
  margin: 0 0 5vh 0;
  object-fit: cover;
  ${media.lessThan("medium")`
    /* screen width is less than 768px (medium) */
    width: 40vw;
    min-width: 40vw;
    height: 15vh;
  `}
  ${media.greaterThan("medium")`
    /* screen width is greater than 1170px (large) */
    width: 20vw;
    min-width: 20vw;
    height: 30vh;
  `}
`;

const Midashi = styled.p`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  text-align: center;
  ${media.lessThan("medium")`
    /* screen width is less than 768px (medium) */
    font-size: 14pt;
    margin: 0 0 2vh 0;
  `}
  ${media.greaterThan("medium")`
    /* screen width is greater than 1170px (large) */
    font-size: 24pt;
    margin: 0 0 5vh 0;
  `}
`;

const Komidashi = styled.p`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  text-align: center;
  ${media.lessThan("medium")`
    /* screen width is less than 768px (medium) */
    font-size: 12pt;
  `}
  ${media.greaterThan("medium")`
    /* screen width is greater than 1170px (large) */
    font-size: 14pt;
  `}
`;